export const voucherPackageSelector = (state) => state.voucherReducer.all;
export const vouchersSelector = (state) => state.voucherReducer.vouchers;
export const detailSelector = (state) => state.voucherReducer.detail;
//
export const redeemSelector = (state) => state.voucherReducer.redeem;

//cashup
export const voucherDateSelector = (state) =>
  state.voucherReducer.voucherByDate;
export const voucherRedeemDateSelector = (state) =>
  state.voucherReducer.voucherRedeemByDate;
